import { useEffect, useRef, useState } from "react";
import { Hash, X } from "lucide-react";
import api from "../lib/api";
import { Input } from "@/components/ui/input";

const LEVEL = { sezione: "Sez.", divisione: "Div.", gruppo: "Gruppo", classe: "Classe", categoria: "Cat.", sottocategoria: "Sottocat." };

export default function AtecoInput({ value, onChange, placeholder = "Codice o descrizione ATECO…", testid = "ateco-input", className = "", clearable = true }) {
  const [q, setQ] = useState(value || "");
  const [hits, setHits] = useState([]);
  const [open, setOpen] = useState(false);
  const [label, setLabel] = useState(null);
  const boxRef = useRef(null);

  useEffect(() => { setQ(value || ""); }, [value]);

  useEffect(() => {
    if (!value) { setLabel(null); return; }
    api.get(`/meta/ateco/${encodeURIComponent(value)}`).then(({ data }) => setLabel(data.label)).catch(() => setLabel(null));
  }, [value]);

  useEffect(() => {
    if (!q || q === value) { setHits([]); return; }
    const t = setTimeout(() => {
      api.get("/meta/ateco", { params: { q, limit: 15 } }).then(({ data }) => { setHits(data); setOpen(true); }).catch(() => {});
    }, 200);
    return () => clearTimeout(t);
  }, [q, value]);

  useEffect(() => {
    const h = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const pick = (a) => { onChange(a.code); setQ(a.code); setOpen(false); };
  const clear = () => { onChange(""); setQ(""); setHits([]); };

  return (
    <div ref={boxRef} className={`relative ${className}`}>
      <div className="relative">
        <Hash className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-slate-400" />
        <Input
          data-testid={testid}
          value={q}
          onChange={(e) => { setQ(e.target.value); if (value && e.target.value !== value) onChange(""); }}
          onFocus={() => hits.length && setOpen(true)}
          onBlur={() => { if (q && !value) onChange(q); }}
          placeholder={placeholder}
          className="pl-8 pr-8 font-mono h-10"
        />
        {clearable && q && <button type="button" data-testid={`${testid}-clear`} onClick={clear} className="absolute right-2 top-1/2 -translate-y-1/2 p-0.5 rounded hover:bg-slate-100 text-slate-400"><X className="w-3.5 h-3.5" /></button>}
      </div>
      {label && <p data-testid={`${testid}-label`} className="text-xs text-teal-700 mt-1 truncate">{label}</p>}
      {open && hits.length > 0 && (
        <div data-testid={`${testid}-suggestions`} className="absolute z-50 mt-1 w-full sm:min-w-[22rem] bg-white rounded-lg border border-slate-200 shadow-xl py-1 max-h-72 overflow-y-auto">
          {hits.map((a) => (
            <button key={a.code} type="button" data-testid={`${testid}-option-${a.code}`} onMouseDown={() => pick(a)} className="w-full text-left px-3 py-1.5 hover:bg-slate-50 flex items-start gap-2.5 text-sm">
              <span className="font-mono text-teal-700 shrink-0 w-20">{a.code}</span>
              <span className="text-slate-700 flex-1 leading-snug">{a.label}</span>
              <span className="text-[10px] uppercase tracking-wider text-slate-400 shrink-0 pt-0.5">{LEVEL[a.level]}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
